import type { VolumeUnit } from '@/utils/unitConversion';

export interface OilEntry {
  id: string;
  time: string;
  location: string;
  bunkerTakenUsg: string;
  costPerUsgAfterTaxUsd: string;
  costUsd: string;
  costLocalCurrency: string;
  totalOnboardUsg: string;
  /**
   * The unit each volume figure is kept in. Every figure has its own, picked
   * beside its field and saved with it: a volume read off the ship's gallon
   * gauges may be priced per liter ashore.
   */
  bunkerTakenUnit: VolumeUnit;
  costPerUnit: VolumeUnit;
  totalOnboardUnit: VolumeUnit;
}

export interface OilLogState {
  date: string;
  entries: OilEntry[];
}

/** The unit as the oil log has always spelled it: US gallons are "USG". */
export const volumeWord = (unit: VolumeUnit): string => (unit === 'L' ? 'Liter' : 'USG');

// Entry times are captured as HH:MM (00:00–23:59) and merged with the log's
// selected date into a full ISO `date_time` for the backend.
export const TIME_RE = /^([01]\d|2[0-3]):([0-5]\d)$/;
